// extracted by mini-css-extract-plugin
export default {"blogRow":"BlogList_blogRow__tXMBL","blogTitle":"BlogList_blogTitle__GECBl","blogDate":"BlogList_blogDate__YLKzN"};